// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--xqIP5{0%{background-position:200% 0}100%{background-position:-200% 0}}.lumen5-tabs{border-bottom:none}.lumen5-tabs .nav-link{border-left:0;border-right:0;border-top:0;border-bottom:2px solid rgba(0,0,0,0);color:rgba(0,0,0,.45)}.lumen5-tabs .nav-link.active{border-color:#5645f5;color:#5a6272}.lumen5-tabs.sm .nav-link{padding-left:.6rem;padding-right:.6rem;padding-top:.75rem;padding-bottom:.5rem}.lumen5-tabs.md .nav-link{padding-top:1rem;padding-bottom:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shimmer-loading": "shimmer-loading--xqIP5"
};
export default ___CSS_LOADER_EXPORT___;
